import { useEffect, useState } from "react";
import { useAccount } from "wagmi";

import {
  getLedgerInjectedProvider,
  isLedgerConnectorId,
} from "@constants/ledger";

const useLedgerLive = () => {
  const { connector } = useAccount();

  const [isLedgerInjected, setIsLedgerInjected] = useState(false);

  useEffect(() => {
    setIsLedgerInjected(Boolean(getLedgerInjectedProvider()));
  }, []);

  // Ledger reaches the app either as the EIP-6963 connector or as the injected
  // fallback, so both ids mean the session is running through Ledger.
  const isLedgerConnected = isLedgerConnectorId(connector?.id);

  const isLedgerLiveENV = isLedgerInjected && isLedgerConnected;

  return { isLedgerConnected, isLedgerInjected, isLedgerLiveENV };
};

export default useLedgerLive;
